import * as React from 'react';

const SvgLoadingOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M20 12a8 8 0 1 1-16 0H2c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2v2a8 8 0 0 1 8 8Z", fill: "currentColor" })));

export { SvgLoadingOutline as default };
